import useCrud from './useCrud'

const useTaskExecutionCitizen = procedureCode => {
  const { create: createTaskExecution, update } = useCrud(`/v1/procedures/${procedureCode}/task_executions`)

  const { mutate: updateTaskExecution } = update()

  return { createTaskExecution, updateTaskExecution }
}
export default useTaskExecutionCitizen
